import React from 'react';
import ReactDOM from 'react-dom/client';
// antd v5 official React 19 compat shim — kills the per-page console warning
// and restores wave/notification internals under React 19 (ROO-186).
import '@ant-design/v5-patch-for-react-19';
import 'katex/dist/katex.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAxiosAuthRecovery } from './api/axiosAuthRecovery';

// Recover from an expired/invalid token (401) on bare-axios calls (ROO-117).
installAxiosAuthRecovery();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
